export default __webpack_public_path__ + "static/media/ficha_medicamento.d2115f43.svg";